module.exports = __webpack_public_path__ + "static/media/12_APOTHEO_LABO_CIZETA.85974198.png";